// Seat colors are tokens in tokens.css (--seat-0 … --seat-7). Labels always accompany them.
export function seatColorVar(index: number): string {
  return `var(--seat-${((index % 8) + 8) % 8})`;
}
